(function () {
  'use strict';
  var routes = window.themeRoutes || { cartAdd: '/cart/add.js', cart: '/cart.js' };

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Bag, ' + count + ' items'); });
  }

  function addToCart(form, button) {
    var labelEl = button && (button.querySelector('[data-label]') || button);
    var original = labelEl ? labelEl.innerHTML : '';
    var errorEl = form.parentElement.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    if (button) button.disabled = true;

    return fetch(routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added.');
          return fetch(routes.cart, { headers: { Accept: 'application/json' } });
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        if (!button) return;
        button.disabled = false;
        button.classList.add('is-ok');
        labelEl.innerHTML = button.hasAttribute('data-quick') ? '&#10003;' : 'Added to bag &#10003;';
        setTimeout(function () {
          button.classList.remove('is-ok');
          labelEl.innerHTML = button.getAttribute('data-idle') || original;
        }, 1600);
      })
      .catch(function (err) {
        if (button) button.disabled = false;
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } else {
          form.submit();
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-add]')) return;
    e.preventDefault();
    addToCart(form, e.submitter || form.querySelector('[type=submit]'));
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var next = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-cart-form] .qty input').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });

  document.querySelectorAll('[data-auto-submit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-ajax-add]');
    var idInput = form.querySelector('[name=id]');
    var addBtn = form.querySelector('[data-add]');
    var addLabel = addBtn.querySelector('[data-label]');
    var qtyInput = form.querySelector('[name=quantity]');
    var bar = root.querySelector('[data-bar]');
    var barBtn = bar && bar.querySelector('button');
    var gallery = root.querySelector('[data-gallery]');

    function money(cents) {
      return data.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, type) {
        var value = cents / 100;
        if (type === 'amount_no_decimals' || type === 'amount_no_decimals_with_comma_separator') return Math.round(value).toLocaleString('en-IN');
        if (type === 'amount_with_comma_separator') return value.toLocaleString('de-DE', { minimumFractionDigits: 2 });
        return value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      });
    }

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (set) {
        var checked = set.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function currentVariant() {
      if (!root.querySelector("[data-option]")) return data.variants[0];
      var picked = selected();
      return data.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === picked[i]; });
      });
    }

    function idleLabel(v) {
      if (!v) return 'Unavailable';
      if (!v.available) return 'Sold out';
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      return 'Add to bag &middot; ' + money(v.price * qty);
    }

    function render() {
      var v = currentVariant();
      root.querySelectorAll('[data-option]').forEach(function (set) {
        var checked = set.querySelector('input:checked');
        var named = set.querySelector('[data-option-value]');
        if (named && checked) named.textContent = checked.value;
      });
      addBtn.disabled = !v || !v.available;
      addLabel.innerHTML = idleLabel(v);
      addBtn.setAttribute('data-idle', idleLabel(v));
      if (barBtn) {
        barBtn.disabled = addBtn.disabled;
        barBtn.innerHTML = idleLabel(v);
      }
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('[data-price]').forEach(function (el) { el.innerHTML = money(v.price); });
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        el.hidden = !(v.compare_at_price > v.price);
        el.innerHTML = v.compare_at_price ? money(v.compare_at_price) : '';
      });
      root.querySelectorAll('[data-save]').forEach(function (el) {
        var onSale = v.compare_at_price > v.price;
        el.hidden = !onSale;
        if (onSale) el.innerHTML = 'You save ' + money(v.compare_at_price - v.price);
      });
      root.querySelectorAll('[data-variant-title]').forEach(function (el) { el.textContent = v.title; });
      if (window.history.replaceState && data.variants.length > 1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (gallery && v.featured_media) {
        var item = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (item && gallery.showMedia && gallery.classList.contains("is-strip")) gallery.showMedia(item, true);
        else if (item && item !== gallery.firstElementChild) gallery.insertBefore(item, gallery.firstElementChild);
      }
    }

    root.querySelectorAll('[data-option] input').forEach(function (input) { input.addEventListener('change', render); });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      if ((parseInt(qtyInput.value, 10) || 0) < 1) qtyInput.value = 1;
      var v = currentVariant();
      if (v) {
        addLabel.innerHTML = idleLabel(v);
        addBtn.setAttribute('data-idle', idleLabel(v));
        if (barBtn) barBtn.innerHTML = idleLabel(v);
      }
    });
    if (barBtn) barBtn.addEventListener('click', function () { addBtn.click(); });
    if (bar) {
      var updateBar = function () { bar.hidden = addBtn.getBoundingClientRect().bottom > 0; };
      window.addEventListener('scroll', updateBar, { passive: true });
      window.addEventListener('resize', updateBar);
      updateBar();
    }
    render();
  });

  document.querySelectorAll('[data-recs-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recs-url'))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs-url]');
        if (fresh && fresh.querySelector('.card')) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.filter[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();

(function () {
  'use strict';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = root.querySelectorAll('[data-vc-slide]');
    var dots = root.querySelectorAll('[data-vc-dot]');
    var pauseBtn = root.querySelector('[data-vc-pause]');
    var seconds = parseInt(root.dataset.interval, 10) || 6;
    var index = 0;
    var timer = null;
    var userPaused = calm;
    var held = false;
    root.style.setProperty('--vc-time', seconds + 's');

    function syncVideos() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === index && !userPaused) {
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-on', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
        slide.querySelectorAll('a').forEach(function (a) {
          if (on) a.removeAttribute('tabindex');
          else a.setAttribute('tabindex', '-1');
        });
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-on', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      syncVideos();
      restart();
    }

    function stop() {
      clearInterval(timer);
      timer = null;
      root.classList.remove('is-running');
    }

    function restart() {
      stop();
      if (userPaused || held || slides.length < 2) return;
      void root.offsetWidth;
      root.classList.add('is-running');
      timer = setInterval(function () { show(index + 1); }, seconds * 1000);
    }

    function setPaused(value) {
      userPaused = value;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-label', value ? 'Play slideshow' : 'Pause slideshow');
        pauseBtn.firstElementChild.innerHTML = value ? '&#9654;' : '&#10074;&#10074;';
      }
      syncVideos();
      restart();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });
    var prev = root.querySelector('[data-vc-prev]');
    var next = root.querySelector('[data-vc-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!userPaused); });

    var stage = root.querySelector('.vc-stage');
    function hold() { held = true; stop(); }
    function release() { held = false; restart(); }
    stage.addEventListener('mouseenter', hold);
    stage.addEventListener('mouseleave', release);
    stage.addEventListener('focusin', hold);
    stage.addEventListener('focusout', release);

    var touchX = null;
    stage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var moved = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(moved) > 40) show(index + (moved < 0 ? 1 : -1));
    }, { passive: true });

    setPaused(calm);
  }

  function initRail(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-rail-track]');
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-rail-item]'));
    if (!items.length) return;

    items.forEach(function (item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-rail-copy', '');
      copy.removeAttribute('data-rail-item');
      copy.querySelectorAll('a, button, input').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      track.appendChild(copy);
    });

    var firstCopy = track.querySelector('[data-rail-copy]');
    function loopWidth() { return firstCopy.offsetLeft - items[0].offsetLeft; }
    function step() { return items[0].offsetWidth + 22; }

    var position = 0;
    var last = null;
    var held = false;
    var auto = root.dataset.auto === 'true' && !calm;
    var speed = parseInt(root.dataset.speed, 10) || 35;
    var resume = null;

    function hold() { held = true; clearTimeout(resume); }
    function releaseSoon() {
      clearTimeout(resume);
      resume = setTimeout(function () { position = track.scrollLeft; held = false; last = null; }, 1200);
    }

    function wrap() {
      var width = loopWidth();
      if (width <= 0) return;
      if (track.scrollLeft >= width) track.scrollLeft -= width;
      else if (track.scrollLeft <= 0) track.scrollLeft += width;
      position = track.scrollLeft;
    }

    function frame(time) {
      if (last !== null && !held && !document.hidden) {
        position += speed * Math.min(time - last, 100) / 1000;
        var width = loopWidth();
        if (width > 0 && position >= width) position -= width;
        track.scrollLeft = position;
      }
      last = time;
      requestAnimationFrame(frame);
    }

    function nudge(direction) {
      hold();
      wrap();
      track.scrollBy({ left: direction * step(), behavior: calm ? 'auto' : 'smooth' });
      releaseSoon();
    }

    root.querySelector('[data-rail-next]').addEventListener('click', function () { nudge(1); });
    root.querySelector('[data-rail-prev]').addEventListener('click', function () { nudge(-1); });
    track.addEventListener('mouseenter', hold);
    track.addEventListener('mouseleave', releaseSoon);
    track.addEventListener('focusin', hold);
    track.addEventListener('focusout', releaseSoon);
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('touchend', releaseSoon, { passive: true });
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { hold(); releaseSoon(); }
    }, { passive: true });
    track.addEventListener('scroll', function () {
      if (held) { var width = loopWidth(); if (width > 0 && track.scrollLeft >= width) track.scrollLeft -= width; }
    }, { passive: true });

    if (auto) requestAnimationFrame(frame);
  }

  function initAll() {
    document.querySelectorAll('[data-vc]').forEach(initCarousel);
    document.querySelectorAll('[data-rail]').forEach(initRail);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

(function () {
  'use strict';
  var phone = window.matchMedia('(max-width: 900px)');

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var items = Array.prototype.slice.call(gallery.children);
    if (items.length < 2) return;
    var stage = null;
    var strip = null;
    var current = null;

    function showMedia(item, moveStrip) {
      current = item;
      stage.innerHTML = item.innerHTML;
      var image = stage.querySelector('img');
      if (image) {
        image.loading = 'eager';
        image.sizes = '100vw';
      }
      stage.classList.remove('is-in');
      void stage.offsetWidth;
      stage.classList.add('is-in');
      items.forEach(function (other) {
        var on = other === item;
        other.classList.toggle('is-on', on);
        if (on) other.setAttribute('aria-current', 'true');
        else other.removeAttribute('aria-current');
      });
      if (moveStrip) {
        var left = item.offsetLeft - (strip.clientWidth - item.offsetWidth) / 2;
        strip.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    gallery.showMedia = showMedia;

    function step(direction) {
      var index = items.indexOf(current) + direction;
      showMedia(items[(index + items.length) % items.length], true);
    }

    function build() {
      gallery.classList.add('is-strip');
      stage = document.createElement('div');
      stage.className = 'gal-stage';
      stage.setAttribute('aria-live', 'polite');
      strip = document.createElement('div');
      strip.className = 'gal-strip';
      items.forEach(function (item, i) {
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + items.length);
        strip.appendChild(item);
      });
      gallery.appendChild(stage);
      gallery.appendChild(strip);
      showMedia(items[0], false);

      strip.addEventListener('click', function (e) {
        var item = e.target.closest('.gal-i');
        if (item) showMedia(item, true);
      });
      strip.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var item = e.target.closest('.gal-i');
        if (!item) return;
        e.preventDefault();
        showMedia(item, true);
      });

      var startX = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var moved = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(moved) > 40) step(moved < 0 ? 1 : -1);
      }, { passive: true });
    }

    function unbuild() {
      gallery.classList.remove('is-strip');
      var ordered = current ? [current].concat(items.filter(function (i) { return i !== current; })) : items;
      ordered.forEach(function (item) {
        item.classList.remove('is-on');
        item.removeAttribute('role');
        item.removeAttribute('tabindex');
        item.removeAttribute('aria-label');
        item.removeAttribute('aria-current');
        gallery.appendChild(item);
      });
      stage.remove();
      strip.remove();
      stage = strip = null;
    }

    function sync() {
      var active = gallery.classList.contains('is-strip');
      if (phone.matches && !active) build();
      else if (!phone.matches && active) unbuild();
    }
    if (phone.addEventListener) phone.addEventListener('change', sync);
    sync();
  });
})();
